import { Form } from 'react-bootstrap';
import InfoHint from './InfoHint';

function AppInput({ label, id, error, hint, ...props }) {
  return (
    <Form.Group controlId={id} className="mb-3">
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control isInvalid={!!error} {...props} />
      {error && <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>}
      {hint && !error && <InfoHint>{hint}</InfoHint>}
    </Form.Group>
  );
}

export default AppInput;
